import * as files from '../components/files.jsx';

class ItemIconBase extends waffle.base.BaseComponent {
  imageText() {
    var imageText = null;
    if (this.state.imageText) {
      imageText = this.state.imageText.replace(/_/g, "");
    }

    if (imageText) {
      return imageText;
    }
    else {
      if (this.state.name) {
        return this.state.name.substring(0, 2);
      }

      return "";
    }
  }
}

class ItemPopover extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    var actions = <div className="actions popover-title">
      <a className="btn btn-sm btn-primary edit-done" onClick={this.doneClicked}>{this.props.iconState.newItem ? "Done" : "Save"}</a>&nbsp;
      <a className="btn btn-sm btn-muted edit-cancel" onClick={this.cancelClicked}>Cancel</a>
    </div>

    if (this.props.iconState.imageFileUUID) {
      return <div className="edit-item-icon">
        <p>If you remove the image you can set a colour and label, or select a new image</p>
        <a className="btn btn-sm btn-danger btn-remove-image" onClick={this.removeClicked.bind(this)}><i className="fa fa-fw fa-remove"> </i>Remove image</a>

        { actions }
      </div>
    } else {
      return <div className="edit-item-icon">
        <p>{"Select a colour and label for your item"}</p>
        <div className="color-picker">
          {
            this.props.colors.map((color, index) => {
              var className = "choice";

              if ('#' + this.props.iconState.backgroundColour == color) {
                className += " active"
              }

              return <a key={index} onClick={this.handleClick.bind(this, color)} className={className} style={{"backgroundColor": color}}></a>
            })
          }
        </div>

        <label>Label:</label>
        <input className="form-control" data-mask="aa" value={this.props.iconState.imageText} onKeyUp={this.imageTextChanged.bind(this)} onChange={this.imageTextChanged.bind(this)}></input>

        <h3 className="popover-title">Upload an image</h3>
        <div className="section">
          <ItemImageUpload ref="imageUpload" />
        </div>

        { actions }
      </div>
    }
  }

  imageTextChanged(event) {
    radio("iconChanged").broadcast({
      "imageText": event.target.value
    });
  }

  removeClicked() {
    radio('iconChanged').broadcast({
      "imageFileUUID": null,
      "imageURL": null,
      "removeImage": true
    });
  }

  doneClicked() {
    radio('iconAction').broadcast({action: "done"});
  }

  cancelClicked() {
    radio("iconAction").broadcast({action: "cancel"})
  }

  handleClick(color) {
    radio("iconChanged").broadcast({
      "backgroundColour": color.substr(1)
    });
  }
}

ItemPopover.defaultProps = {
  colors: ["#0694DC", "#1ABC9C", "#2ECC71", "#9B59B6", "#34495E", "#F1C40F", "#E67E22", "#E74C3C", "#BDC3C7", "#95A5A6"]
}

class ItemIconEditor extends ItemIconBase {
  componentDidMount() {
    radio("iconChanged").subscribe(data => {
      this.setState(data);
    });

    radio("iconAction").subscribe(data => {
      if (data.action == "done") {
        this.initialState = this.state;
        this.refs.popover.hide();

        if (!this.state.newItem) {
          // Pressing done on the icon must save the item
          var domElement = ReactDOM.findDOMNode(this);
          $(domElement).closest("form").yocoForm().submit()
        }
      }
      else if (data.action == "cancel") {
        this.setState(this.initialState);
        this.refs.popover.hide();
      }
    });

    radio("fileUploadEvent").subscribe((data) => this.fileUploadEvent(data));

    // List events
    radio("listItemChanged").subscribe((data) => this.listItemChanged(data));
    radio("listAddItem").subscribe((data) => this.addItem(data));

    // We need to fish for keypress events on the item name
    $(ReactDOM.findDOMNode(this)).closest("form").find("input[name='name']").on("keyup", (event) => this.nameChanged(event));
  }

  fileUploadEvent(data) {
    if (data.event == "complete") {
      var result = data.result.data;

      this.setState({
        "imageFileUUID": result.uuid,
        "imageURL": result.url,
        "removeImage": false
      })
    }
  }

  clearState() {
    var blankState = {};
    for (var key in this.state) {
      blankState[key] = null;
    }

    blankState.backgroundColour = "0694DC";

    this.setState(blankState);
  }

  listItemChanged(data) {
    this.clearState();
    this.setState(data.item);

    this.initialState = data.item;
  }

  addItem(data) {
    this.clearState();
    this.setState({
      newItem: true
    });
    this.initialState = this.state;
  }

  nameChanged(event) {
    this.setState({
      name: event.target.value
    });
  }

  imageClicked(event) {
    this.refs.popover.show();
  }

  render() {
    var currentState = this.state;

    var overlay = (
      <ReactBootstrap.Popover title="Edit Item Icon">
        <ItemPopover iconState={this.state}/>
      </ReactBootstrap.Popover>
    );

    var backgroundStyle = {
      "background": "#" + this.state.backgroundColour
    };

    if (this.state.imageURL) {
      backgroundStyle = {
        background: 'url("' + this.state.imageURL + '")',
        backgroundSize: "cover"
      }
    }

    return <div className="item-icon">
      <div className="item-background inner" style={backgroundStyle} onClick={this.imageClicked.bind(this)}>
        {this.state.imageURL ? "" : <div className="item-text inner">{ this.imageText() }</div> }
      </div>

      <ReactBootstrap.OverlayTrigger container={this} ref='popover' trigger='click' placement='bottom' overlay={overlay}>
        <a id="edit-item">Edit Icon</a>
      </ReactBootstrap.OverlayTrigger>

      <input name="imageFileUUID" type="hidden" value={this.state.imageFileUUID}></input>
      <input name="backgroundColour" type="hidden" value={this.state.backgroundColour}></input>
      <input name="imageText" type="hidden" value={this.imageText()}></input>
      <input name="imageURL" type="hidden" value={this.state.imageURL}></input>
      <input name="removeImage" type="hidden" value={this.state.removeImage}></input>
    </div>;
  }
}


class ItemIcon extends ItemIconBase {
  getDefaultState() {
    return $.extend(super.getDefaultState(), this.props);
  }

  render() {
    var backgroundStyle = {
      "background": "#" + this.state.backgroundColour
    };

    if (this.state.imageURL) {
      backgroundStyle = {
        background: 'url("' + this.state.imageURL + '")',
        backgroundSize: "cover"
      }
    }

    return <div className="item-icon smaller">
      <div className="item-background inner" style={backgroundStyle}>
        {this.state.imageURL ? "" : <div className="item-text inner">{ this.imageText() }</div> }
      </div>
    </div>
  }
}

class ItemImageUpload extends files.FileUpload {

}

ItemImageUpload.defaultProps = {
  title: "Upload image",
  fileUploadSettings: {
    disableImageResize: false,
    imageForceResize: true,
    imageCrop: true,
    imageMinWidth: 256,
    imageMinHeight: 256,
    imageMaxWidth: 256,
    imageMaxHeight: 256
  }
}

module.exports = {
  ItemIconBase: ItemIconBase,
  ItemIconEditor: ItemIconEditor,
  ItemIcon: ItemIcon
}
